import { Card, Grid, Paper, Typography, Link, CardContent, Stack, TextField, TableHead, TableCell, TableRow, Table, TableBody, Box, Tooltip, Button, TableContainer, Checkbox, CardHeader } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Loading from '../../components/Loading';
import { useCreateOrderMutation, useListOrdersQuery, useUpdateOrderMutation } from '../../features/model/orderSlice';

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

let USD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

const OrdersDash = () => {
    let query_filters = { status_in: "waiting for shipment,pending shipment" };

    const { data, error, isLoading } = useListOrdersQuery(query_filters);

    if (isLoading) {
      return <Loading />;
    }
    if (error || !data) {
      return <div>Error</div>
    }

    const sortedObjects = data.objects.slice().sort((a, b) => a.received.localeCompare(b.received))

    // <Link href={`${process.env.REACT_APP_PREFIX}/reports/orders`} underline='none'>Overdue order list</Link>
    // <p></p>
    return <Paper><Card>
        <CardHeader title="Orders" titleTypographyProps={{variant: "h2"}} subheader="" />
        <CardContent>
            <p>In queue: {sortedObjects.length}</p>
        </CardContent>
        </Card></Paper>
}

export { OrdersDash };